import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/reasons', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOne(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/reasons/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    add(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/reasons', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    edit(ctx, data) {
      return new Promise((resolve, reject) => {
        const url = `/reasons/${data.id}`
        axios
          .put(url, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    del(ctx, id) {
      return new Promise((resolve, reject) => {
        const url = `/reasons/${id}`
        axios
          .delete(url)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
